import type { AxiosError } from 'axios';
import { i18n } from 'i18n';

import { errorCodes } from './constants';
import type { ErrorType, ServerError } from './types';

const DEFAULT_CODE_ERROR = 'UNKNOWN_ERROR';

export const normalizeError = (error?: AxiosError<ServerError>): ErrorType => {
  const unknownError = i18n.t('errorCodes.UNKNOWN_ERROR');

  if (error && error.response) {
    try {
      const code = error.response.data.code;
      const alertMessage = error.response.data.alert?.message;
      const alertMessageFromCode =
        errorCodes[code] && i18n.t(`errorCodes.${code}`, { defaultValue: undefined });

      return {
        status: error.response.status,
        code: code || DEFAULT_CODE_ERROR,
        alert: alertMessageFromCode || alertMessage || unknownError,
        message: typeof error.response === 'string' ? error.response : error.response.data.message,
      };
    } catch {
      return {
        status: error.response.status,
        code: DEFAULT_CODE_ERROR,
        alert: unknownError,
        message: unknownError,
      };
    }
  }

  if (error && error.request) {
    return {
      status: error.request.status,
      code: DEFAULT_CODE_ERROR,
      alert: unknownError,
      message: unknownError,
    };
  }

  return {
    message: unknownError,
    alert: unknownError,
  };
};

export const isServerError = (error?: ErrorType): boolean =>
  !!error?.status && error?.status >= 500;
